import { render, staticRenderFns } from "./BoFooter.vue?vue&type=template&id=54e575c6&"
import script from "./BoFooter.vue?vue&type=script&lang=js&"
export * from "./BoFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports